export const GET_ARTEFACTS_ERROR = "Une erreur est survenue lors du chargement des décorations";
export const DELETE_ARTEFACT_ERROR = "Une erreur est survenue lors de la suppression de l'élément décoratif";
export const UPDATE_ARTEFACT_ERROR = "Une erreur est survenue lors de la mise-à-jour de l'élément décoratif";
export const ADD_ARTEFACT_ERROR = "Une erreur est survenue lors de l'ajout de l'élément décoratif";

export const GET_ARTEFACT_TYPES_ERROR = "Une erreur est survenue lors du chargement des types de décorations";


// WEBPACK FOOTER //
// ./src/errors/artefacts.js